/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import PropTypes from 'prop-types'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Anchor } from '@nexigendigital/nxui'
import { addToItems, removeFromItemsByID } from 'store/slices/shopSlice'
import { BaseHosting } from 'models/shop'
import { useAppDispatch, useAppSelector } from 'store/hooks'

/**********************************************************************************************************
 *   INTERFACE
 **********************************************************************************************************/
interface Props {
    isItemAdded: boolean,
    currentProduct: BaseHosting,
    setCurrentProduct: (product: BaseHosting) => void
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function Select ({ isItemAdded, currentProduct, setCurrentProduct }: Props) {
    const dispatch = useAppDispatch()
    const { baseHosting } = useAppSelector((state) => state.shop)

    if (isItemAdded) {
        return (
            <Anchor
                className={'select'}
                color={'primary'}
                onClick={() => {
                    dispatch(removeFromItemsByID({ product_id: currentProduct.product_id }))
                    setCurrentProduct(baseHosting)
                }}
            >
                Remove
            </Anchor>
        )
    }

    return (
        <Anchor className={'select'} color={'primary'} onClick={() => dispatch(addToItems(currentProduct))}>
            Configure
        </Anchor>
    )
}

/**********************************************************************************************************
 *   COMPONENT PROPTYPES
 **********************************************************************************************************/
Select.propTypes = {
    isItemAddedToCart: PropTypes.bool,
    currentProduct: PropTypes.object,
    setCurrentProduct: PropTypes.func
}
